require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _CardContent = _interopRequireDefault(require("./CardContent"));

var _CardActions = _interopRequireDefault(require("./CardActions"));

var _CardCover2 = _interopRequireDefault(require("./CardCover"));

var _CardTitle2 = _interopRequireDefault(require("./CardTitle"));

var _Surface = _interopRequireDefault(require("../Surface"));

var _theming = require("../../core/theming");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Card/Card.tsx";

var Card = function (_React$Component) {
  (0, _inherits2["default"])(Card, _React$Component);

  function Card() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Card);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Card)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      elevation: new _reactNative.Animated.Value(_this.props.elevation)
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePressIn", function () {
      var scale = _this.props.theme.animation.scale;

      _reactNative.Animated.timing(_this.state.elevation, {
        toValue: 8,
        duration: 150 * scale,
        useNativeDriver: false
      }).start();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePressOut", function () {
      var scale = _this.props.theme.animation.scale;

      _reactNative.Animated.timing(_this.state.elevation, {
        toValue: _this.props.elevation,
        duration: 150 * scale,
        useNativeDriver: false
      }).start();
    });
    return _this;
  }

  (0, _createClass2["default"])(Card, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          cardElevation = _this$props.elevation,
          onLongPress = _this$props.onLongPress,
          onPress = _this$props.onPress,
          style = _this$props.style,
          theme = _this$props.theme,
          testID = _this$props.testID,
          accessible = _this$props.accessible,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["children", "elevation", "onLongPress", "onPress", "style", "theme", "testID", "accessible"]);
      var elevation = this.state.elevation;
      var roundness = theme.roundness;
      var total = React.Children.count(children);
      var siblings = React.Children.map(children, function (child) {
        return React.isValidElement(child) && child.type ? child.type.displayName : null;
      });
      return React.createElement(_Surface["default"], (0, _extends2["default"])({
        style: [{
          borderRadius: roundness,
          elevation: elevation
        }, style]
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 149
        }
      }), React.createElement(_reactNative.TouchableWithoutFeedback, {
        delayPressIn: 0,
        disabled: !(onPress || onLongPress),
        onLongPress: onLongPress,
        onPress: onPress,
        onPressIn: onPress ? this.handlePressIn : undefined,
        onPressOut: onPress ? this.handlePressOut : undefined,
        testID: testID,
        accessible: accessible,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 153
        }
      }, React.createElement(_reactNative.View, {
        style: styles.innerContainer,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 163
        }
      }, React.Children.map(children, function (child, index) {
        return React.isValidElement(child) ? React.cloneElement(child, {
          index: index,
          total: total,
          siblings: siblings
        }) : child;
      }))));
    }
  }]);
  return Card;
}(React.Component);

(0, _defineProperty2["default"])(Card, "Content", _CardContent["default"]);
(0, _defineProperty2["default"])(Card, "Actions", _CardActions["default"]);
(0, _defineProperty2["default"])(Card, "Cover", _CardCover2["default"]);
(0, _defineProperty2["default"])(Card, "Title", _CardTitle2["default"]);
(0, _defineProperty2["default"])(Card, "defaultProps", {
  elevation: 1
});

var styles = _reactNative.StyleSheet.create({
  innerContainer: {
    flexGrow: 1,
    flexShrink: 1
  }
});

var _default = (0, _theming.withTheme)(Card);

exports["default"] = _default;